/**
 * `sync-daily-to-master` plan. Single atomic call on the BE
 * (`POST /api/v2/route/{routeId}/master/stops/sync-daily`); the pipeline is
 * preflight + the one step + verify. Strategy-independent — `v1-bulk` reuses
 * this with its own strategy label since there's no separate v1-era endpoint
 * for sync-daily.
 */
import type {
  Deps,
  OperationPlan,
  PipelineStep,
  SyncDailyToMasterIntent,
} from 'types/modules/routing'

import { makePreflightStep } from '../steps/preflight'
import { makeSyncDailyToMasterStep } from '../steps/syncDailyToMaster'
import { makeVerifyStep } from '../steps/verify'

const STRATEGY_ID = 'v2-pipeline' as const

export const buildSyncDailyToMasterPipeline = (
  intent: SyncDailyToMasterIntent,
  deps: Deps,
): OperationPlan => ({
  strategy: STRATEGY_ID,
  intent,
  steps: [
    makePreflightStep({ intent }, deps) as PipelineStep,
    makeSyncDailyToMasterStep(
      {
        routeId: intent.routeId,
        dayOfWeek: intent.dayOfWeek,
        serviceDates: intent.serviceDates,
        syncFuture: intent.syncFuture,
      },
      deps,
    ) as PipelineStep,
    makeVerifyStep({ intent }, deps) as PipelineStep,
  ],
})
